import React from 'react'
import { FaDownload } from 'react-icons/fa'

interface DocumentProps {
    href: string
    title?: string
    display?: 'full' | 'link'
}

const Document: React.FC<DocumentProps> = ({ href, title, display = 'full' }) => {
    const showPreview = display === 'full'

    return (
        <div className="bg-surface rounded-lg p-6">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-semibold my-2">{title ?? "Attached Document"}</h2>
                <a
                    href={href}
                    download
                    className="btn btn-primary inline-flex items-center gap-2"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FaDownload />
                    Download
                </a>
            </div>
            {showPreview && (
                <div className="aspect-[1/1] w-full bg-gray-100 rounded-lg overflow-hidden mt-4">
                    <iframe
                        src={href}
                        className="w-full h-full"
                        title="PDF Document"
                    />
                </div>
            )}
        </div>
    )
}

export default Document